module.exports = __webpack_public_path__ + "img/tishi.38eb8c78.png";